<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo logo-width" v-if="!collapsed">{{sysName}}</el-col>
      <el-col :span="10">
        <div class="tools" @click.prevent="collapse">
          <i class="el-icon-s-unfold" v-if="collapsed"></i>
          <i class="el-icon-s-fold" v-if="!collapsed"></i>
        </div>
      </el-col>
      <el-col :span="4" class="userinfo">
		  <el-button class="logout" type="text" @click.native="logout">退出</el-button>
       <!-- <el-dropdown trigger="hover">
          <span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="Editpwd">修改密码</el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <aside class="menu-collapsed" v-if="!collapsed">
        <!--导航菜单-->
        <el-menu router>
          <template v-for="(v,i) in menulist">
            <el-submenu :key="i" v-if="v.children" :index="v.to">
              <template slot="title">
                <i :class="v.icon"></i>
                {{v.title}}
              </template>
              <el-menu-item
                v-show="v.children"
                v-for="child in v.children"
                :key="child.to"
                :index="child.to"
              >{{child.title}}</el-menu-item>
            </el-submenu>
            <el-menu-item :key="i" v-else :index="v.to" router>
              <i :class="v.icon"></i>
              {{v.title}}
            </el-menu-item>
          </template>
        </el-menu>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="breadcrumb-container">
            <strong class="title">
				{{$route.name}}
				<el-button type="text" size="medium" style="margin-left: 16px;" @click="$router.back(-1)" v-show="$route.meta.canBack">返回上一页</el-button>
			</strong>
			
            <el-breadcrumb separator="/" class="breadcrumb-inner">
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">{{ item.name }}</el-breadcrumb-item>			  
            </el-breadcrumb>			
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="el-zoom-in-center" mode="out-in">
              <router-view :key="$route.fullPath"></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data: () => ({
    sysName: "自造窗管理系统",
    collapsed: false,
    sysUserName: "",
    menulist: [
      {
        icon: "el-icon-s-home",
        title: "首页",
        to: "/index"
      },
      {
        icon: "el-icon-s-home",
        title: "数据统计",
		to: 'sjtj',
		children: [
			{
				title: '用户数据',
				to: '/userStastic'
			},
			{
				title: '炫图',
				to: '/renderStastic'
			},
			// {
			// 	title: '页面数据',
			// 	to: '/pageStastic'
			// },
			// {
			// 	title: '按钮数据',
			// 	to: '/buttonStastic'
			// }
		]
      },
      {
        icon: "el-icon-s-home",
        title: "订单看板",
        to: "/orderBoard"
      },
      {
        icon: "el-icon-s-home",
        title: "销售设置",
        to: "/SalesSettings"
      },
      {
        icon: "el-icon-s-home",
        title: "合作推广",
        to: "1",
        children: [
          {
            title: "推广管理",
            to: "/promotionman"
          },
          {
            title: "新建推广",
            to: "/promotionadd"
          }
        ]
      },
      {
        icon: "el-icon-s-home",
        title: "付款记录",
        to: "/PaymentLog"
      },
      {
        icon: "el-icon-s-home",
        title: "提现申请记录",
        to: "/CashLog"
      },
      {
        icon: "el-icon-s-home",
        title: "系统管理",
        to: "2", is_admin: 1,
        children: [
          // {
          //   title: "报表管理",
          //   to: "/report-manager"
          // },
          // {
          //   title: "功能模块管理",
          //   to: "/modules-manager"
          // },
          {
            title: "开账号",
            to: "/create-account"
          },
          {
            title: "关账号",
            to: "/del-account"
          },
          // {
          //   title: "升级账号",
          //   to: "/update-account"
          // },
          // {
          //   title: "设置代理商",
          //   to: "/set-proxy"
          // },
		  {
		    title: "账号管理",
		    to: "/account-manage"
		  },
		  {
		    title: "代理商列表",
		    to: "/proxy-list"
		  },
		  {
		    title: "异常用户",
		    to: "/abnormal-users"
		  }
        ]
      },
	  {
	    icon: "el-icon-s-home",
	    title: "迁移公式",
	    to: "/migrateProduct"
	  },
	  {
	    icon: "el-icon-s-home",
	    title: "门窗资讯",
	    to: "/articleList"
	  },
	  {
	    icon: "el-icon-s-home",
	    title: "官网留言",
	    to: "/customerMessage"
	  },
      // {
      //   icon: "el-icon-s-custom",
      //   title: "用户管理",
      //   to: "1",
      //   children: [
      //     {
      //       title: "添加检测员",
      //       to: "/addworker"
      //     },
      //     {
      //       title: "管理检测员",
      //       to: "/manworker"
      //     }
      //   ]
      // },
      // {
      //   icon: "el-icon-s-opportunity",
      //   title: "检测点",
      //   to: "2",
      //   children: [
      //     {
      //       title: "添加检测点",
      //       to: "/addmonitor"
      //     },
      //     {
      //       title: "管理检测点",
      //       to: "/manmonitor"
      //     }
      //   ]
      // },
      // {
      //   icon: "el-icon-guide",
      //   title: "设置指标",
      //   to: "/settarget"
      // }
    ],
    is_admin: 0,
  }),
  methods: {
    //折叠导航栏
    collapse() {
      this.collapsed = !this.collapsed;
    },
    //退出登录
    logout() {
      // var _this = this;
      // this.$confirm("确认退出吗?", "提示", {
      //   type: "warning"
      // })
      //   .then(() => {
          
      //   })
      //   .catch(() => {});
	  sessionStorage.clear();
	  this.$router.push("/login");
    },
    //点击修改密码跳转修改密码界面
    Editpwd() {
      this.$router.push("/editpwd");
    }
  },
  mounted() {
	  var userinfo = JSON.parse(sessionStorage.getItem("userinfo")) 
    this.sysUserName = userinfo.nickname || userinfo.company_name;
    this.is_admin = userinfo.is_admin || 0;
    if (this.is_admin == 0)
      this.menulist = this.menulist.filter(v=> { return v.is_admin!=1; })
  }
};
</script>
<style scoped>
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}
.logo-width {
  width: 200px;
}
.main {
  display: flex;
  position: absolute;
  top: 60px;
  bottom: 0px;
  /* height: 100%; */
}
.header {
  height: 60px;
  line-height: 60px;
  color: #fff;
  background: #2ca2fc;
}
.userinfo {
  text-align: right;
  padding-right: 35px;
  float: right;
}
.userinfo-inner {
  cursor: pointer;
  color: #fff;
}
.logo {
  height: 60px;
  font-size: 22px;
  padding-left: 20px;
  padding-right: 20px;
  border-color: rgba(238, 241, 146, 0.3);
  border-right-width: 1px;
  border-right-style: solid;
}
.tools {
  padding: 0px 23px;
  width: 14px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}
.menu-collapsed {
  width: 200px;
  height: 100%;
  border-right: solid 1px #e6e6e6;
  overflow: auto;
}
.el-menu {
  border: 0px;
}
.content-container {
  flex: 1;
  overflow-y: scroll;
  padding: 20px;
}
.breadcrumb-container .title {
  width: 200px;
  float: left;
  color: #475669;
}
.breadcrumb-container .breadcrumb-inner {
  float: right;
}
.content-wrapper {
  box-sizing: border-box;
}
.logout{
	color: #fff !important;
}
</style>
